import Icon from '../components/Icon.vue'

Icon.register({"mars-stroke-h":{"width":480,"height":512,"paths":[{"d":"M476.2 247.5L420.3 191.6C412.7 184 399.8 189.4 399.8 200.1V224H376V204C376 197.4 370.6 192 364 192H324C317.4 192 312 197.4 312 204V224H284.4C278.6 198.4 265.7 174.1 245.8 154.2 189.6 98 98.4 98 42.2 154.2-14 210.4-14 301.6 42.2 357.8 98.4 414 189.6 414 245.8 357.8 265.7 337.9 278.6 313.6 284.4 288H312V308C312 314.6 317.4 320 324 320H364C370.6 320 376 314.6 376 308V288H399.9V311.9C399.9 322.6 412.8 327.9 420.4 320.4L476.3 264.5C480.9 259.8 480.9 252.2 476.2 247.5zM200.6 312.6C169.4 343.8 118.7 343.8 87.5 312.6 56.3 281.4 56.3 230.7 87.5 199.5 118.7 168.3 169.4 168.3 200.6 199.5 231.8 230.6 231.8 281.4 200.6 312.6z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/mars-stroke-h.js
// module id = Mc1A
// module chunks = 0